export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
export const GOOGLE_PLACE_ID = process.env.REACT_APP_GOOGLE_PLACE_ID;